import { css } from "@emotion/react";
import { arc, pie } from "d3";
import React from "react";
import useD3 from "../util/use-d3";

const margin = 5;

export default function PieChart({ data, colors, height = "10rem", namePrefix }) {
    const [elemRef, dimensionRef] = useD3(
        (svg, { width, height }) => {
            // Clone data and add an "other" item
            const pieData = [...(data || [])];
            const other = pieData.reduce((acc, d) => {
                acc -= d.downloads;
                return acc;
            }, pieData.length ? pieData[0].totalDownloads : 1);

            pieData.push({
                [`${namePrefix}Name`]: "_other",
                downloads: other,
                [`${namePrefix}Rank`]: pieData.length + 1
            });

            const radius = Math.min(width, height) / 2 - margin;

            const pieGenerator = pie()
                .value(d => d.downloads)
                .sort(d => d[`${namePrefix}Rank`]);

            const chartArea = svg.select(".chart-area");
            chartArea.attr("transform", `translate(${width / 2},${height / 2})`);

            chartArea
                .selectAll("path")
                .data(pieGenerator(pieData))
                .join("path")
                .attr(
                    "d",
                    arc()
                        .innerRadius(radius / 2)
                        .outerRadius(radius)
                )
                .attr("fill", function(d) {
                    const name = d.data[`${namePrefix}Name`];
                    return name == "_other" ? "#eee" : colors(name);
                })
                .style("opacity", 0.85);
        },
        [data, colors, namePrefix, height]
    );

    return (
        <div
            ref={dimensionRef}
            style={{
                marginBottom: "1rem"
            }}
        >
            <svg
                ref={elemRef}
                css={css`
                    display: block;
                    height: ${height};
                    width: 100%;
                `}
            >
                <g className="chart-area" />
            </svg>
        </div>
    );
}
